// improve this one as well
// we can use the convection of records filteredview
// tell me if you need it uploaded
// import React from "react";

// const ReadOnlyRow = ({
//   isLoadingDelete,
//   contact,
//   handleEditClick,
//   handleDeleteClick,
//   handleDownloadRow
// }) => {
//   return (
//     <tr className="trrows hover-red bg-white ">
//       <td className="bg-gold">{contact.id}</td>
//       <td>{contact.farmerid}</td>
//       <td>{contact.username}</td>
//       <td>{contact.email}</td>
//       <td>{contact.password}</td>
//       <td>{contact.phone}</td>
//       <td style={{ whiteSpace: "nowrap" }}>{contact.joined}</td>
//       <td style={{ whiteSpace: "nowrap" }}>{contact.company}</td>

//       <td>{contact.lastactive}</td>
//       <td>{contact.category}</td>
//       <td>{contact.status}</td>

//       <td>

//           <label className=" hover-bg-transparent"onClick={(event) => handleEditClick(event, contact)}>
//             <i className="fas fa-edit f2 hover-gold"></i>
           
//           </label>
   
    
         
//          <label className="ml2 hover-bg-transparent"  onClick={() => handleDeleteClick(contact.id)}>
//             <i className="fas fa-trash f2 hover-yellow red"></i>
          
//           </label>
//       </td>
//     </tr>
//   );
// };

// export default ReadOnlyRow;



// // new and improved
// import React from "react";

// const ReadOnlyRow = ({
//   contact,
//   handleEditClick,
//   handleDeleteClick,
//   selectedRecords = [],
//   handleSelectRecord = () => {},
//   deletingId, // id of the row currently being deleted, or null
// }) => {
//   const isDeleting = deletingId === contact.id;

//   const statusValue = String(contact?.status || "").toLowerCase();

//   // FIX: colors the status pill based on actual status instead of just
//   // printing the raw string, so it's scannable at a glance like the
//   // Approved/Not Approved badges in Records.
//   const statusBadgeClass =
//     statusValue === "active"
//       ? "bg-light-green dark-green b--green"
//       : statusValue === "disabled"
//       ? "bg-washed-red dark-red b--light-red"
//       : "bg-light-yellow dark-yellow b--gold"; // pending / unknown

//   return (
//     <tr className={`trrows hover-red bg-white ${isDeleting ? "o-50" : ""}`}>
//       {/* Select */}
//       <td className="tc">
//         <input
//           type="checkbox"
//           checked={selectedRecords.includes(contact.id)}
//           onChange={() => handleSelectRecord(contact.id)}
//         />
//       </td>
//       <td className="bg-gold">{contact.id}</td>
//       <td>{contact.farmerid}</td>
//       <td>{contact.username}</td>
//       <td>{contact.email}</td>
//       <td>{contact.password}</td>
//       <td>{contact.phone}</td>
//       <td style={{ whiteSpace: "nowrap" }}>{contact.joined}</td>
//       <td style={{ whiteSpace: "nowrap" }}>{contact.company}</td>
//       <td>{contact.lastactive}</td>
//       <td>{contact.category}</td>
//       <td>
//         <span className={`dib br-pill ph3 pv1 f7 fw6 ba ${statusBadgeClass}`}>
//           {contact.status || "-"}
//         </span>
//       </td>
//       <td>
//         <label
//           className="hover-bg-transparent"
//           onClick={(event) => handleEditClick(event, contact)}
//         >
//           <i className="fas fa-edit f2 hover-gold"></i>
//         </label>

//         <label
//           className="ml2 hover-bg-transparent"
//           onClick={() => !isDeleting && handleDeleteClick(contact.id)}
//           title={isDeleting ? "Deleting..." : "Delete"}
//         >
//           {isDeleting ? (
//             <i className="fas fa-spinner fa-spin f2 red"></i>
//           ) : (
//             <i className="fas fa-trash f2 hover-yellow red"></i>
//           )}
//         </label>
//       </td>
//     </tr>
//   );
// };

// export default ReadOnlyRow;


// ReadOnlyRow.js (Users table)
// Styled to match the Records page's ReadOnlyRow.js: striped rows, pill
// status badges instead of plain text, icon-only action buttons, and a
// per-row "deleting" state so a slow delete doesn't look frozen.

import React from "react";

const ReadOnlyRow = ({
  contact,
  handleEditClick,
  handleDeleteClick,
  selectedUsers = [],
  handleSelectUser = () => {},
  deletingId, // id of the row currently being deleted, or null
}) => {
  const status = String(contact?.status || "").toLowerCase();
  const category = contact?.category || "-";

  const isDeleting = deletingId === contact.id;

  const statusBadge = () => {
    if (status === "active") {
      return (
        <span className="dib br-pill ph3 pv2 bg-light-green dark-green fw6 f7 ba b--green">
          ● Active
        </span>
      );
    }
    if (status === "pending") {
      return (
        <span className="dib br-pill ph3 pv2 bg-light-yellow dark-gray fw6 f7 ba b--gold">
          ⏳ Pending
        </span>
      );
    }
    return (
      <span className="dib br-pill ph3 pv2 bg-washed-red dark-red fw6 f7 ba b--light-red">
        ⛔ Disabled
      </span>
    );
  };

  const categoryBadge = () => {
    const isFarmer = String(category).toLowerCase() === "farmer";
    return (
      <span
        className={`dib br-pill ph3 pv2 fw6 f7 ba ${
          isFarmer
            ? "bg-washed-blue dark-blue b--blue"
            : "bg-washed-purple purple b--purple"
        }`}
      >
        {category}
      </span>
    );
  };

  return (
    <tr
      className={`
        striped--light-gray
        hover-bg-near-white
        bb
        b--black-10 fw4
        ${isDeleting ? "o-50" : ""}
      `}
    >
      {/* Select */}
      <td className="pa2 tc nowrap">
        <input
          type="checkbox"
          checked={selectedUsers.includes(contact.id)}
          onChange={() => handleSelectUser(contact.id)}
        />
      </td>

      {/* ID */}
      <td className="pa2 nowrap">{contact.id}</td>

      {/* Farmer ID */}
      <td className="pa2 nowrap">{contact.farmerid || "-"}</td>

      {/* Username */}
      <td className="pa2 nowrap fw6">{contact.username}</td>

      {/* Email */}
      <td className="pa2 nowrap">{contact.email}</td>

      {/* Phone */}
      <td className="pa2 nowrap">{contact.phone}</td>

      {/* Company */}
      <td className="pa2 nowrap">{contact.company}</td>

      {/* Category */}
      <td className="pa2 tc nowrap">{categoryBadge()}</td>

      {/* Status */}
      <td className="pa2 tc nowrap">{statusBadge()}</td>

      {/* Joined */}
      <td className="pa2 tc nowrap">{contact.joined || "-"}</td>

      {/* Last Active */}
      <td className="pa2 tc nowrap">{contact.lastactive || "-"}</td>

      {/* Actions */}
      <td className="pa2 tc nowrap">
        <button
          type="button"
          className="bn bg-transparent pointer mh1"
          onClick={(event) => handleEditClick(event, contact)}
          title="Edit"
        >
          <i className="fas fa-edit f4 gold hover-orange"></i>
        </button>

        <button
          type="button"
          className="bn bg-transparent pointer mh1"
          onClick={() => handleDeleteClick(contact.id, contact.category)}
          disabled={isDeleting}
          title={isDeleting ? "Deleting..." : "Delete"}
        >
          {isDeleting ? (
            <i className="fas fa-spinner fa-spin f4 red"></i>
          ) : (
            <i className="fas fa-trash f4 red hover-dark-red"></i>
          )}
        </button>
      </td>
    </tr>
  );
};

export default ReadOnlyRow;